import { Column } from '../components/tables/DataTable';
import { Conversion } from '../types';

interface ConversionsColumnsOptions {
  isTopEarner: (user: string) => boolean;
  renderAccessCell: (conversion: Conversion) => any;
  renderUserCell: (conversion: Conversion) => any;
  renderGMTCell: (conversion: Conversion) => any;
  renderWIBCell: (conversion: Conversion) => any;
  renderNetworkCell: (conversion: Conversion) => any;
  renderEarningCell: (conversion: Conversion) => any;
  renderIPCell: (conversion: Conversion) => any;
}

/**
 * Generate conversions table columns with consistent styling
 * Ensures identical column configuration across Dashboard and Conversions pages
 *
 * This function takes render functions as parameters since we can't import JSX components
 * in a utility file. The pages provide the render functions which maintain component imports.
 */
export function getConversionsColumns(options: ConversionsColumnsOptions): Column<Conversion>[] {
  const {
    renderGMTCell,
    renderWIBCell,
    renderUserCell,
    renderAccessCell,
    renderNetworkCell,
    renderEarningCell,
    renderIPCell,
  } = options;

  return [
    {
      key: 'datetime',
      label: 'GMT',
      sortable: true,
      render: renderGMTCell,
    },
    {
      key: 'datetime',
      label: 'WIB',
      sortable: true,
      render: renderWIBCell,
    },
    {
      key: 'user',
      label: 'User',
      sortable: true,
      render: renderUserCell,
    },
    {
      key: 'country',
      label: 'Access',
      sortable: false,
      render: renderAccessCell,
    },
    {
      key: 'network',
      label: '',
      sortable: true,
      render: renderNetworkCell,
    },
    {
      key: 'payout',
      label: 'Earning',
      sortable: true,
      render: renderEarningCell,
    },
    {
      key: 'ip_address',
      label: 'IP Address',
      sortable: false,
      render: renderIPCell,
    },
  ];
}
